import React, { useState, useEffect } from "react";
import axios from "axios";
import InputImage from "../../../../component/Input/InputImage";
import { confirmModal } from "../../../../helpers/PromptUtils";

const ImagesRoom = ({ id }) => {
    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_IMAGES = "api/staynest/dashboard/Rooms/images";
    const PATH_IMAGES_UPLOAD = "api/staynest/dashboard/Rooms/uploadimage";

    const [images, setImages] = useState([]);
    const [error, setError] = useState(null);

    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
        }
    };

    useEffect(() => {
        if (id) {
            fetchData(`${BASE_URL}${PATH_IMAGES}?id=${id}`).then((data) => {
                setImages(data);
            });
        }
    }, [id]);

    return (
        <div className="p-4">
            <h2 className="text-xl font-bold mb-4">Image Gallery {id}</h2>

            <div className="grid lg:grid-cols-4 md:grid-cols-2 xs:grid-cols-1 grid-cols-1 gap-4">
                <InputImage attr={{
                    "width": "1000",
                    "height": "667",
                    "name": "image_room",
                    "placeholder": "Foto Ruangan"
                }} handleCroppedFoto={async (value) => {                    
                    try {
                        const response = await axios.post(`${BASE_URL}${PATH_IMAGES_UPLOAD}`, {
                            "room_id" : id,
                            "photo_url" : value
                        }, {
                            headers: {
                                'Content-Type': 'application/json',
                                // 'Authorization': `Bearer ${getToken()}`
                            }
                        });
            
                        const confirmed = confirmModal(response.data);
                        if (confirmed) {
                            window.location.reload();
                        }
                    } catch (error) {
                        alert(error.response.data);
                    }
                }} />
                {images?.map(image => {
                    return (
                        <div>
                            <img
                                src={`${BASE_URL}/upload/staynest/${image['photo_url']}`}
                                alt="External Example"
                                className="w-full h-auto rounded shadow"
                            />
                        </div>
                    );
                })}

            </div>
        </div>
    );
}

export default ImagesRoom;
